import { useMutation } from '@apollo/client';
import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertControlGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetControlGroupsFlatDocument,
  InsertControlGroupDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useInsertControlGroupTRPC } from './useInsertControlGroupTRPC';

type InsertControlGroupInput = {
  Title: string;
  Description: string;
  Owner: string;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertControlGroup = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [insertControlGroupGraphQL, graphqlState] = useMutation(
    InsertControlGroupDocument,
    {
      refetchQueries: [{ query: GetControlGroupsFlatDocument }],
      awaitRefetchQueries: true,
    }
  );

  const trpcMutation = useInsertControlGroupTRPC();

  const insertControlGroup = async (
    variables: InsertControlGroupInput
  ): Promise<InsertControlGroupMutation> => {
    if (trpcEnabled) {
      return trpcMutation.insertControlGroup(variables);
    }

    const result = await insertControlGroupGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to insert action update');
    }

    return result.data;
  };

  return {
    insertControlGroup,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
